<template>
    <div class="wrapper">
        <div
            v-if="showDescription"
            class="value-container description-container"
        >
            <named-value
                v-if="texts.description !== ''"
                :name="texts.information"
                variant="stacked"
                v-html="texts.description"
            >
            </named-value>
        </div>

        <div
            v-if="showPrices"
            class="value-container prices-container"
        >
            <named-value :name="texts.price" />

            <named-value
                v-for="passengerTypePrice in product.passengerTypePrices"
                :key="passengerTypePrice.passengerTypeId"
                :name="
                    getPassengerTypeById(passengerTypePrice.passengerTypeId)
                        .nameSingular | passenger
                "
                secondary
            >
                {{ passengerTypePrice.price | prettyPrice }}
            </named-value>
        </div>

        <div
            v-if="showValidTravelArea"
            class="value-container valid-travel-area-container"
        >
            <named-value
                v-if="texts.validityText !== ''"
                :name="texts.valid"
                variant="stacked"
            >
                {{ texts.validityText }}
            </named-value>
        </div>

        <div
            v-if="showValidity"
            class="value-container validity-container"
        >
            <named-value
                :name="validityPeriodText"
                variant="stacked"
            >
                <span v-if="product.validWindowEndInstance == null">
                    Fra {{ product.validWindowStartInstance | momentDate }}
                </span>
                <span v-else>
                    {{ product.validWindowStartInstance | momentDate }} -
                    {{ product.validWindowEndInstance | momentDate }}
                </span>
            </named-value>
        </div>
    </div>
</template>

<script>
import NamedValue from "@/components/elements/NamedValue";
import { mapGetters } from "vuex";

export default {
    components: {
        NamedValue
    },
    props: {
        product: {
            type: Object,
            required: true
        },
        showPrices: {
            type: Boolean,
            required: false,
            default: true
        },
        showDescription: {
            type: Boolean,
            required: false,
            default: true
        },
        showValidity: {
            type: Boolean,
            required: false,
            default: true
        },
        showValidTravelArea: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed: {
        texts() {
            return {
                ...this.$t("block_fixedprice_ticket_product_information"),
                ...this.product.texts[this.$i18n.locale]
            };
        },
        validityPeriodText() {
            return this.product.restrictToDate
                ? this.texts.valid_whole_day
                : this.texts.valid_period_part_one +
                      " " +
                      this.$options.filters.minuteToNiceString(
                          this.product.validDurationMinutes
                      ) +
                      " " +
                      this.texts.valid_period_part_two;
        },
        getPassengerName(passengerTypeId) {
            return this.getPassengerTypeById(passengerTypeId).nameSingular;
        },
        ...mapGetters({
            getPassengerTypeById: "passenger/getPassengerTypeById"
        })
    }
};
</script>

<style scoped>
.prices-container {
    max-width: 230px;
}

.value-container {
    margin-bottom: 1.5rem;
}
</style>
